export default "__VITE_ASSET__IYG3hW6J__"